module.exports = __webpack_public_path__ + "static/media/i-logo.a21aa677.svg";